export default __webpack_public_path__ + "static/media/transcription_icon.1e7f72be.svg";